import React, { useId, useMemo } from 'react';
import { MathJax } from 'better-react-mathjax';

/**
 * 生成内容的哈希值，用于创建唯一的 key
 * @param {string} str - 输入字符串
 * @returns {string} - 哈希值
 */
const hashContent = (str) => {
  if (!str) return 'empty';
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash;
  }
  return Math.abs(hash).toString(36);
};

/**
 * 安全的 MathJax 组件
 * 使用 dynamic 属性和唯一 key 来避免 DOM 操作错误
 * @param {Object} props - 传递给 MathJax 的所有属性
 * @param {React.ReactNode} props.children - 要渲染的数学内容
 */
function SafeMathJax({ children, ...props }) {
  const uniqueId = useId();

  // 如果内容为空，直接返回 null
  if (!children) {
    return null;
  }

  // 生成基于内容的唯一 key，确保内容变化时组件完全重新创建
  const contentKey = useMemo(() => {
    return `mathjax-${uniqueId}-${hashContent(String(children))}`;
  }, [uniqueId, children]);

  return (
    <MathJax
      key={contentKey}
      dynamic
      hideUntilTypeset="first"
      {...props}
    >
      {children}
    </MathJax>
  );
}

export default SafeMathJax;
